module.exports = __webpack_public_path__ + "img/tornado.f0e7d9d5.png";